module.exports = __webpack_public_path__ + "img/rain-svgrepo-com.dcb0be37.svg";